module.exports = __webpack_public_path__ + "img/shopify.99fc96e5.png";